const calculateNiceInterval = (min: number, max: number, targetTicks: number = 8, axis: 'x' | 'y')
  : { interval: number; niceMin: number; niceMax: number; tickAmount: number } => {
  const range = max - min;
  if (range === 0) return { interval: 1, niceMin: Math.max(0, min), niceMax: max, tickAmount: 1 };

  const rawInterval = range / targetTicks;

  const magnitude = Math.floor(Math.log10(rawInterval));
  const normalizedInterval = rawInterval / (10 ** magnitude);

  let niceNormalizedInterval;
  if (normalizedInterval <= 1) {
    niceNormalizedInterval = 1;
  } else if (normalizedInterval <= 2) {
    niceNormalizedInterval = 2;
  } else if (normalizedInterval <= 5) {
    niceNormalizedInterval = 5;
  } else {
    niceNormalizedInterval = 10;
  }

  const interval = niceNormalizedInterval * (10 ** magnitude);

  const niceMin = (axis === 'x') ? Math.max(0, Math.floor(min / interval) * interval) : Math.floor(min / interval) * interval;
  const niceMax = Math.ceil(max / interval) * interval;

  const tickAmount = Math.round((niceMax - niceMin) / interval);

  return { interval, niceMin, niceMax, tickAmount };
};

export default calculateNiceInterval;
